const DEGREES_IN_HALF_CIRCLE = 180;

export const degreesToRadians = (degrees: number): number =>
  degrees * (Math.PI / DEGREES_IN_HALF_CIRCLE);

export const radiansToDegrees = (radians: number): number =>
  radians * (DEGREES_IN_HALF_CIRCLE / Math.PI);
